import React from 'react'
import Header from '../layout/Header'
// import Input from "../elements/Input/Input"
// import Dropdown from '../coreComponents/dropdown/Dropdown'
// import common from '../methods/common'
// import userIcon from "../assets/img/icons/user.png"
// import Calendar from './Calendar'
// import attendenceModals from "../modals/attendenceModals"
// import Actions from '../components/widgets/Actions'
// import AttendenceCalender from '../components/widgets/AttendenceCalender'
// import EditAttendence from '../components/widgets/EditAttendence'
import User from '../components/widgets/User'
import Attendence from '../components/Attendence'
// import AddMeeting from '../components/widgets/AddMeeting'

const Dashboard = () => {
    return (
        <div>
            <Header />
            <User />
            <Attendence />
            {/* <AddMeeting /> */}
        </div>
    )
}

export default Dashboard
